import { PaymentModeCodes } from '@payment/const';
import { CUSTOM_ICON_TYPE } from '@shared/models';

export type VariantIcons = {
  [key in PaymentModeCodes]: CUSTOM_ICON_TYPE;
};

export const VARIANT_ICONS: VariantIcons = {
  [PaymentModeCodes.Sbrf]: CUSTOM_ICON_TYPE.CREDIT_CARD,
  [PaymentModeCodes.CashCardReceive]: CUSTOM_ICON_TYPE.CREDIT_CARD,
  [PaymentModeCodes.CashCardShop]: CUSTOM_ICON_TYPE.SHOP,
  [PaymentModeCodes.CardDelivery]: CUSTOM_ICON_TYPE.CREDIT_CARD,
  [PaymentModeCodes.CashDelivery]: CUSTOM_ICON_TYPE.RUBLE,
  [PaymentModeCodes.Sbp]: CUSTOM_ICON_TYPE.SBP,
  [PaymentModeCodes.Plait]: CUSTOM_ICON_TYPE.PLAIT,
  [PaymentModeCodes.QrDelivery]: CUSTOM_ICON_TYPE.QR,
};
